import React from 'react'
import { Message } from 'rsuite'
import './styles.less'

export default function KycMessage({ schema }) {
  return (
    <div className="message-icon" style={{ marginTop: 10 }}>
      <Message
        showIcon
        type={'error'}
        title={schema.title || ''}
        description={<p dangerouslySetInnerHTML={{ __html: schema.label || '' }} />}
      />
    </div>
  )
}
